import { defineMessages, IntlShape } from "react-intl";

import { EntityType, MapFilterEntityType } from "@mapmycustomers/shared/types/entity";

const messages = defineMessages<MapFilterEntityType>({
  [EntityType.COMPANY]: {
    id: "component.filtering.mapFilterButton.filterableEntityType.company",
    defaultMessage: "Company Filters",
    description: "Company filters type title on Map page's filters",
  },
  [EntityType.DEAL]: {
    id: "component.filtering.mapFilterButton.filterableEntityType.deal",
    defaultMessage: "Deal Filters",
    description: "Deal filters type title on Map page's filters",
  },
  [EntityType.PERSON]: {
    id: "component.filtering.mapFilterButton.filterableEntityType.person",
    defaultMessage: "Person Filters",
    description: "Person filters type title on Map page's filters",
  },
  universal: {
    id: "component.filtering.mapFilterButton.filterableEntityType.universal",
    defaultMessage: "Universal Filters",
    description: "Universal filters type title on Map page's filters",
  },
});

const getMapEntityTypeDisplayName = (intl: IntlShape, entityType: MapFilterEntityType) =>
  intl.formatMessage(messages[entityType]);

export default getMapEntityTypeDisplayName;
